import { render } from "./MailReSender.vue?vue&type=template&id=02b63b5d&scoped=true"
import script from "./MailReSender.vue?vue&type=script&lang=js"
export * from "./MailReSender.vue?vue&type=script&lang=js"

import "./MailReSender.vue?vue&type=style&index=0&id=02b63b5d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b63b5d"]])

export default __exports__